var map = {
	"./": 487,
	"./OldUi": 2692,
	"./OldUi.js": 2692,
	"./SpireonNew": 2693,
	"./SpireonNew.js": 2693,
	"./SpireonOld": 2694,
	"./SpireonOld.js": 2694,
	"./index": 487,
	"./index.js": 487,
	"./style": 375,
	"./style.js": 375
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4196;